import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IOption } from '@core/interface';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownService } from '../../../services/dropdowm.service';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule],
  selector: 'agenda-customer-ui-dropdown-v2',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DropdownComponent implements OnChanges {
  showOptions = false;
  showAlert = false;
  placeHolder = '';

  constructor(private dropdownService: DropdownService) {
    this.dropdownService.activeDropdown$.subscribe(activeId => {
      if (activeId !== this.idDropdown) {
        this.showOptions = false;
      }
    });
  }

  @Input() idDropdown!: number;

  @Input() firstlabel = '';
  @Input() alertMessage = '';
  @Input() hasNoSelectFirstItem = false;
  @Input() options: IOption[] = [];
  @Input() icon!: string;

  @Output() newOptionSelected = new EventEmitter<number>();
  @Output() toggle = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      const selected = this.options?.find(option => option.selected && !option.disabled);

      this.placeHolder = selected ? selected.label : '';
    }
  }

  showDropdown(): void {
    this.showAlertMessage(false);
    this.showOptions = !this.showOptions;
    if (this.showOptions) {
      this.dropdownService.setActiveDropdown(this.idDropdown);
    } else {
      this.dropdownService.setActiveDropdown(null);
    }
  }

  showAlertMessage(show: boolean): void {
    this.showAlert = show;
  }

  onSelectedOption(event: Event): void {
    const e = event.target as HTMLInputElement;
    const disabled = e.getAttribute('data-disabled');
    const id = e.getAttribute('data-id');

    this.options.forEach(option => {
      option.selected = false;
    });

    const selectedOption = this.options.find(option => option.id === Number(id));
    if (selectedOption) {
      selectedOption.selected = true;
    }

    if (disabled === 'false') {
      this.placeHolder = e.innerHTML;
      this.newOptionSelected.emit(Number(id));
      this.showDropdown();
    } else {
      this.showAlertMessage(true);
    }
  }

}

